import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mapApiLanguageToI18n } from './queries/language.mapper';
import { URL_PARAM_LANGUAGE } from '../constants/language.constants';

/**
 * Synchronizes URL language parameter to i18n on mount and when URL changes.
 * One-way sync only (URL → i18n). Does NOT update URL when language changes.
 */
export function useLanguageFromUrl(): void {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const urlLanguage = searchParams.get(URL_PARAM_LANGUAGE);
    const targetLanguage = mapApiLanguageToI18n(urlLanguage);

    if (targetLanguage && i18n.language !== targetLanguage) {
      i18n.changeLanguage(targetLanguage);
    }
  }, [searchParams, i18n]);
}
